var map = {
	"./en/cgu.json": [
		27010,
		7010
	],
	"./en/translation.json": [
		80992,
		992
	],
	"./fr/cgu.json": [
		28701,
		8701
	],
	"./fr/translation.json": [
		5875,
		5875
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 66843;
module.exports = webpackAsyncContext;